import { useState } from "react";
import "../../styles/addTags.css";

export default function AddTags({ isOpen, onClose, onSubmit }) {
  const [inputValue,     setInputValue]     = useState("");
  const [availableTags,  setAvailableTags]  = useState([]);
  if (!isOpen) return null;
  function handleCreate() {
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    if (!availableTags.includes(trimmed)) {
      setAvailableTags((prev) => [...prev, trimmed]);
    }
    setInputValue("");
  }
  function handleKeyDown(e) {
    if (e.key === "Enter") handleCreate();
  }
  function handleRemoveTag(tag) {
    setAvailableTags((prev) => prev.filter((t) => t !== tag));
  }
  function handleBackdrop(e) {
    if (e.target === e.currentTarget) onClose?.();
  }
  return (
    <div className="at-backdrop" onMouseDown={handleBackdrop}>
      <div className="at-modal">
        <h2 className="at-title">Add Tags</h2>
        <p className="at-subtitle">
          Create tags to assign tags corresponding to a particular report.
        </p>
        <div className="at-input-row">
          <input
            type="text"
            className="at-input"
            placeholder="Add Tag"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button className="at-create-btn" onClick={handleCreate}>
            CREATE
          </button>
        </div>
        <div className="at-tags-section">
          <p className="at-tags-label">Available Tags</p>
          <div className="at-tags-list">
            {availableTags.map((tag) => (
              <span key={tag} className="at-tag-chip">
                {tag}
                <button
                  className="at-tag-remove"
                  onClick={() => handleRemoveTag(tag)}
                  title="Remove tag"
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>
        {/* Close */}
        <div className="at-close-row">
          <button className="at-close-btn" onClick={onClose}>CLOSE</button>
        </div>
      </div>
    </div>
  );
}